<template>
 <Title>about</Title>
about
</template>

<script>
import axios from 'axios';

export default {



 mounted() {
const urlParams = new URLSearchParams(window.location.search);
const code_data=  urlParams.get('code');
const state_data=  urlParams.get('state');
    console.log(code_data);

const url = 'https://ddz.zhuxinedu.com/api/index/ww_get_user_info'; //简道云工种表单
    const headers = {
        'Content-Type': 'application/json', // 设置请求头为JSON格式
      };
      const data = {
      
        code:code_data,
        state:state_data


      };

    
  axios.post(url, data, { headers })
        .then(response => {




        })
        .catch(error => {
        
          console.error('Error:', error); // 处理错误情况
        });

}
}
</script>